/**
 * Validates label props based on existing children.
 */
const buttonLabelValidator = function () {
  let componentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Button';
  return _ref => {
    let {
      'aria-label': ariaLabel,
      children
    } = _ref;
    if (!(ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.trim()) && !children) {
      return new Error("".concat(componentName, " component requires either children or a valid aria-label."));
    }
    return null;
  };
};

export { buttonLabelValidator };
